import React, { useEffect, useState, useContext } from "react";
import {
  Shimmer,
  ShimmerElementType,
  IShimmerElement,
  ThemeProvider,
  mergeStyles,
  mergeStyleSets,
  createTheme,
  ShimmerElementsGroup,
} from "@fluentui/react";

const ShimmerStudyRows = () => {
  const [containerHeight, setContainerHeight] = useState(() => {
    const newScreenHeight = window.innerHeight;
    const monitorScreenHeightThreshold = 820;
    if (newScreenHeight >= monitorScreenHeightThreshold) {
      return "60vh";
    } else {
      return "45vh";
    }
  });

  const classNames = mergeStyleSets({
    wrapper: {
      selectors: {
        "& > .ms-Shimmer-container": {
          padding: "10px 10px",
        },
      },
      background: "#040910",
      boxSizing: "border-box",
      paddingTop:'20px'
    },
  });

  const getShimmerStyles = () => {
    return {
      shimmerWrapper: [{}],
      shimmerLine: [
        {
          borderRadius: "10px !important",
        },
      ],
      shimmerGap: [
        {
          borderRadius: "7px !important",
          backgroundColor: "red !important",
        },
      ],
    };
  };

  const customThemeForShimmer = createTheme({
    body: {
      background: "red",
    },
    palette: {
      // palette slot used in Shimmer for main background
      neutralLight: "rgb(103, 102, 102)",
      // palette slot used in Shimmer for tip of the moving wave
      neutralLighter: "rgb(70, 70, 70)",
      // palette slot used in Shimmer for all the space around the shimmering elements
      white: "#0078D4",
    },
  });

  const shimmerTableHeaders = [
    { type: ShimmerElementType.circle, width: "2%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },

    { type: ShimmerElementType.line, width: "20%", height: 40 },
    { type: ShimmerElementType.gap, width: "3%" },
  ];
  


  return (
    <>
      <div className="study-list-main-container">
        <ThemeProvider theme={customThemeForShimmer}>
          <div className={classNames.wrapper}>
          <Shimmer
            shimmerColors={{
              background: "#040910",
            }}
            styles={getShimmerStyles()}
            shimmerElements={shimmerTableHeaders}
          />
            <div style={{marginTop:'10px'}}></div>
            <ShimmerRow />
            <ShimmerRow />
            <ShimmerRow />
            <ShimmerRow />
            <ShimmerRow />
            <ShimmerRow />
            
            
          </div>
        </ThemeProvider>
      </div>
    </>
  );
};

export default ShimmerStudyRows;

export const ShimmerRow = () => {

    const classNames = mergeStyleSets({
        wrapper: {
          selectors: {
            "& > .ms-Shimmer-container": {
              padding: "10px 10px",
            },
          },
          background: "#040910",
          boxSizing: "border-box",
        },
      });

      const getShimmerStyles = () => {
        return {
          shimmerWrapper: [{width:'100%'}],
          shimmerLine: [
            {
              borderColor:'red !important',  
              borderRadius: "10px !important",
            },
          ],
          shimmerGap: [
            {
              background:"#040910",
              borderRadius: "7px !important",
              backgroundColor: "red !important",
            },
          ],
        };
      };

      const firstColumn = [
        { type: ShimmerElementType.circle, width: "1%", height: 30 }, 
      ];
    
      const secondColumn = [
        
        { type: ShimmerElementType.gap, width: "4%", height: 20 },
    
        { type: ShimmerElementType.line, width: "20%", height: 20 },
        { type: ShimmerElementType.gap, width: "3%", height: 20 },
    
        { type: ShimmerElementType.line, width: "20%", height: 20 },
        { type: ShimmerElementType.gap, width: "3%", height: 20 },
    
        { type: ShimmerElementType.line, width: "20%", height: 20 },
        { type: ShimmerElementType.gap, width: "3%", height: 20 },
    
        { type: ShimmerElementType.line, width: "20%", height: 20 },
        { type: ShimmerElementType.gap, width: "3%", height: 20 },
    
        { type: ShimmerElementType.line, width: "20%", height: 20 },
        { type: ShimmerElementType.gap, width: "3%", height: 20 },
    
        { type: ShimmerElementType.line, width: "20%", height: 20 },
        { type: ShimmerElementType.gap, width: "4%", height: 20 },
      ];

    return (
        <>
          <div className={classNames.wrapper} style={{ display: "flex", flexDirection: "row",width:'100%' }}>
            <div style={{marginLeft:'10px'}}>
              <Shimmer
                shimmerColors={{
                  background: "#040910",
                }}
                styles={getShimmerStyles()}
                shimmerElements={firstColumn}
              />
              </div>
              <div style={{width:'100%',display:'flex',flexDirection:'column'}}>
              <Shimmer 
                shimmerColors={{
                    background: "#040910",
                }}
                styles={getShimmerStyles()}
                shimmerElements={secondColumn} 
               />
                <div style={{marginBottom: "10px" }}></div>
                 <Shimmer 
                    shimmerColors={{
                        background: "#040910",
                    }}
                    styles={getShimmerStyles()}
                    shimmerElements={secondColumn} 
                 />
                 <div style={{marginBottom: "10px" }}></div>
                 <Shimmer 
                    shimmerColors={{
                        background: "#040910",
                    }}
                    styles={getShimmerStyles()}
                    shimmerElements={secondColumn} 
                 />
              </div>
              
            </div>
        <div style={{ borderTop: "1px solid #201f1e", marginBottom: "20px", marginTop: "20px" }}></div>
        </>
    )
}
